export const ChannelProviderTypes = [
    'Webchat',
    'Facebook',
    'Instagram',
    'Whatsapp',
] as const;

export type ChannelProviderType = (typeof ChannelProviderTypes)[number];
